import { useState } from "react";
import { faqs } from "@/mocks/about";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100/60">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            <i className="ri-question-answer-line text-primary-500 mr-2"></i>常见问题
          </h2>
          <p className="text-sm text-foreground-600 mt-1">关于番茄漫画的常见疑问</p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div key={index} className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</span>
                <i className={`text-foreground-500 text-sm flex-shrink-0 transition-transform duration-200 ${
                  openIndex === index ? "ri-subtract-line" : "ri-add-line"
                }`}></i>
              </button>
              {openIndex === index && (
                <div className="px-4 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}